import * as React from 'react';
import InfoBox from 'react-google-maps/lib/addons/InfoBox';
import { LinkHelper } from '../../routes';
import Icon from 'react-fa';
import isNumber from 'lodash/isNumber'
const styles = require('./SearchMap.less') as any;
declare var google;

const PlaceInfoBox = ({marker, show, close}) => (
  (show && google && marker ?
	 <InfoBox position={new google.maps.LatLng(marker.position)} onCloseClick={close} options={{enableEventPropagation: true, disableAutoPan: true}}>
		 <div className={styles.InfoBoxContent}>
			 <div className={styles.closeButton} onClick={close} ><Icon name="times-circle-o" /></div>
			 <h1>{marker.place.name}</h1>
			 <hr />
			 {isNumber(marker.place.arb.rating.personalized) && <LinkHelper to={`/place/${marker.place.id}`}>View Reviews<Icon name="arrow-circle-right" /></LinkHelper>}
			 <LinkHelper to={`/place/${marker.place.id}?reviewing`}>
				 {marker.place.arb.rating.user_rated ? 'Edit Your Review' : 'Write a review' }
				 <Icon name="arrow-circle-right" />
			 </LinkHelper>
		 </div>
	 </InfoBox> : null)
);

export default PlaceInfoBox;



// WEBPACK FOOTER //
// ./src/app/components/SearchMap/PlaceInfoBox.tsx